import React from 'react';
import ListIcon from '@material-ui/icons/List';
import StoreIcon from '@material-ui/icons/Store';
import {  VIEW_PRODUCTS_AGENTS, VIEW_STORES,  } from "./../../../Routes/paths";


export const categories = [
      { id: 'View Products', icon: <ListIcon />, active: true, link: VIEW_PRODUCTS_AGENTS },
      { id: 'View Stores', icon: <StoreIcon />, link: VIEW_STORES },
      {id: 'Logout', icon:  <StoreIcon />, link: ""}
]